import React from 'react';
import { Box } from '@chakra-ui/react';
import { useLyricsTheme } from '../context/LyricsThemeContext';
import AlbumGradient from './AlbumGradient';

interface BackgroundProps {
  albumImageUrl?: string;
}

/**
 * Background component that renders either a solid color or a gradient background
 * based on the current theme settings
 */
const Background: React.FC<BackgroundProps> = ({ albumImageUrl }) => {
  const { backgroundType, backgroundColor, isDarkMode, isLightMode } = useLyricsTheme();
  
  // Render gradient background if selected and album image is available
  if (backgroundType === 'gradient' && albumImageUrl) {
    return <AlbumGradient imageUrl={albumImageUrl} />;
  }
  
  // Render solid background
  if (backgroundType === 'solid') {
    return (
      <Box
        className={`solid-background ${isDarkMode ? 'dark-mode' : 'light-mode'}`}
        backgroundColor={backgroundColor}
        zIndex={0}
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        transition="background-color 0.3s ease"
      />
    );
  }
  
  // Fallback - empty background
  return null;
};

export default Background; 